import { SearchDomain } from '../../types/SearchDomain.ts';
import { useSearchDomainConfig } from '../SearchDomainConfigProvider';

interface SearchResultTabLabelProps {
  domain: SearchDomain;
}

export const SearchResultTabLabel = ({ domain }: SearchResultTabLabelProps) => {
  const { searchConfigByDomain } = useSearchDomainConfig();
  const searchConfig = searchConfigByDomain(domain);
  return searchConfig.title;
};
